import { use } from 'react';

import { ExclusivePanelContext, type ExclusivePanelContextValue } from './ExclusivePanelContext';

/**
 * Frozen fallback used when no <ExclusivePanelProvider> is present. This lets
 * MapView (which is also rendered standalone on the savi route and in tests,
 * with no provider) keep working unchanged: setActivePanel becomes a no-op and
 * activePanel is always null, so cross-panel coordination is simply inert.
 */
const NOOP_VALUE: ExclusivePanelContextValue = Object.freeze({
    activePanel: null,
    setActivePanel: () => {},
});

/**
 * Reads the single "active panel" signal used to keep the Layers, Filters, POI
 * and Stats sliding panels mutually exclusive across the route/MapView tree
 * boundary. Returns a harmless no-op value when used outside a provider.
 */
export function useExclusivePanel(): ExclusivePanelContextValue {
    return use(ExclusivePanelContext) ?? NOOP_VALUE;
}
